import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Button } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const ConfirmDialog = ({
  children,
  confirm,
  handleCloseConfirmDialog,
  isLoadingConfirm,
  titleFontWeigth,
  openConfirm,
  title,
}) => {
  const { css } = useStyles();

  const handleConfirmation = () => {
    confirm();
    handleCloseConfirmDialog();
  };

  return (
    <Dialog
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 45, 117, 0.6)',
        },
      }}
      classes={{
        paperScrollPaper: css({
          width: '100%',
          maxWidth: 500,
          borderRadius: 10,
          position: 'relative',
          overflow: 'visible',
        }),
      }}
      onClose={handleCloseConfirmDialog}
      open={openConfirm}
    >
      <IconButton
        className={css({
          position: 'absolute',
          background: '#FFFFFF',
          color: '#152652',
          top: -10,
          right: -10,
          '&:hover': {
            background: '#045ff9',
            color: 'white',
          },
        })}
        onClick={handleCloseConfirmDialog}
        size="small"
      >
        <Close fontSize="small" />
      </IconButton>
      <DialogTitle
        className={css({
          background: '#045ff9',
          borderTopLeftRadius: 10,
          textAlign: 'center',
          fontWeight: titleFontWeigth ? titleFontWeigth : 500,
        })}
        id="alert-dialog-title"
      >
        {title}
      </DialogTitle>
      <DialogContent
        style={{
          display: children ? 'block' : 'none',
          alignSelf: 'center',
          fontSize: '13.500px',
        }}
      >
        {children}
      </DialogContent>
      <DialogActions
        disableSpacing
        style={{ columnGap: 10, padding: '22px 42px' }}
      >
        <Button
          autoFocus
          color="primary"
          disableElevation
          disabled={isLoadingConfirm}
          onClick={handleConfirmation}
          variant="contained"
          fullWidth
        >
          Confirmer
        </Button>
        <Button
          color="primary"
          onClick={handleCloseConfirmDialog}
          variant="outlined"
          disableElevation
          fullWidth
        >
          Annuler
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.propTypes = {
  openConfirm: PropTypes.bool,
  confirm: PropTypes.func,
  children: PropTypes.node,
  title: PropTypes.node,
  handleCloseConfirmDialog: PropTypes.func,
  isLoadingConfirm: PropTypes.bool,
};

export default ConfirmDialog;
